import React, {useCallback, useEffect, useRef} from 'react';
import ChannelHeader from "./ChannelHeader";
import {useBotStoreReducer} from "./BotStore";
import styled from "styled-components";
import Loading from "./Loading";
import BotTaskList from "./BotTaskList";
import BotTaskInteraction from "./BotTaskInteraction";
import BotTasksSummary from "./BotTasksSummary";

const ChannelChatContainer = styled.div`
    display: grid;
    width: 340px;
    height: calc(8px + 56px + 165px + 330px);
    box-shadow: 0 3px 6px #00000029;
    background-color: white;
    min-height: calc(8px + 56px + 165px + 330px);
    align-content: flex-end;
`;

type Props = {
    conversation: any;
}

function BotTasks(props: Props) {
    const {conversation} = props;
    const mounted = useRef(false);
    const {state, dispatch} = useBotStoreReducer();
    const {loading, isReviewing, showSummaryModal} = state;

    const goBackHandler = useCallback(
        () => {
            dispatch({type: "GO_BACK"});
        },
        [dispatch],
    );

    useEffect(() => {
        if (mounted.current) return;
        // @ts-ignore
        if (conversation && conversation.friendlyName.includes('workplace_bot')) {
            mounted.current = true;
            dispatch({
                type: "SET_UP",
                conversation: conversation,
                loading: false,
            });
        } else {
            mounted.current = true;
            dispatch({
                type: "SET_UP",
                conversation: conversation,
                loading: false,
            });
        }
    }, [conversation, dispatch]);

    if (loading) {
        return <Loading containerHeight={'calc(8px + 56px + 165px + 330px)'}/>
    }

    return (
        <>
            <ChannelChatContainer data-id={"container-" + conversation.sid} data-sid={conversation.sid}>
                <ChannelHeader conversation={conversation} channelDispatch={dispatch} goBack={isReviewing}
                               goBackHandler={goBackHandler} kind={'TASK'}/>
                <BotTaskList visibility={isReviewing ? "hidden" : "visible"}/>
                {isReviewing && <BotTaskInteraction/>}
            </ChannelChatContainer>
            {showSummaryModal && <BotTasksSummary/>}
        </>
    );
}

export default BotTasks;